// WhatsApp chats of the helpdesk. Mirrors the helpdesk API (`v1/whatsapp/*`); dates are ISO 8601.

export enum EWhatsappConversationStatus {
  OPEN = 'open',
  PENDING = 'pending',
  RESOLVED = 'resolved',
  CLOSED = 'closed',
}

export type TWhatsappDirection = 'in' | 'out';

export type TWhatsappMessageType = 'text' | 'image' | 'audio' | 'video' | 'document' | 'sticker' | 'location'
  | 'contacts' | 'template' | 'button' | 'interactive' | 'reaction' | 'unsupported';

// received = inbound; the rest follow Meta's delivery statuses for outbound messages.
export type TWhatsappMessageStatus = 'received' | 'queued' | 'sent' | 'delivered' | 'read' | 'failed';

export interface IWhatsappStatus {
  enabled: boolean;
  configured: boolean;
  display_phone_number: string | null;
}

export interface IWhatsappMessagePreview {
  id: number;
  direction: TWhatsappDirection;
  type: TWhatsappMessageType;
  body: string | null;
  created_at: string;
}

export interface IWhatsappConversation {
  id: number;
  wa_id: string;
  phone: string;
  contact_name: string | null;
  status: EWhatsappConversationStatus;
  assignee_email: string | null;
  ticket_id: number | null;
  unread_count: number;
  last_message: IWhatsappMessagePreview | null;
  last_message_at: string | null;
  last_inbound_at: string | null;
  // Meta only allows free text within 24h of the customer's last message; afterwards, templates only.
  window_open: boolean;
  window_expires_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface IWhatsappMedia {
  mime: string;
  filename: string | null;
  // null while an outbound file isn't uploaded to Meta yet, or if the upload failed.
  url: string | null;
}

export interface IWhatsappLocation {
  latitude: number;
  longitude: number;
  name: string | null;
  address: string | null;
}

export interface IWhatsappMessage {
  id: number;
  conversation_id: number;
  wamid: string;
  direction: TWhatsappDirection;
  type: TWhatsappMessageType;
  body: string | null;
  media: IWhatsappMedia | null;
  location: IWhatsappLocation | null;
  template_name: string | null;
  status: TWhatsappMessageStatus;
  error: {code: number | string; message: string} | null;
  sent_by_user_id: number | null;
  sent_by_email: string | null;
  sent_by_name: string | null;
  created_at: string;
  // Changes with every delivery status from Meta; the poll asks for messages updated since the newest one.
  updated_at: string;
}

export interface IWhatsappTemplate {
  name: string;
  language: string;
  status: string;
  category: string;
  body: string;
  parameters_count: number;
}

export interface IWhatsappTemplateSend {
  name: string;
  language: string;
  parameters: string[];
}

export interface IWhatsappConversationFilters {
  page?: number;
  per_page?: number;
  search?: string;
  statuses?: EWhatsappConversationStatus[];
  // 'me' | 'unassigned' | an email
  assignee?: string;
}
